export default __webpack_public_path__ + "static/media/07.68015958.png";